import React from "react";
import { useGlobalContext } from "../contextProvider/ContextProvider";
import general from "../styles/General.module.scss";

const TopNavigation = ({
  loading,
  previousStepTitle,
  currentTitle,
  nextStepTitle,
}) => {
  const {
    navigationHeadline,
    currentStep,
    totalSteps,
    progressPercentage,
    submitted,
  } = useGlobalContext();

  // fetch steps

  if (!loading) {
    return (
      <div style={{ marginBottom: "25px" }}>
        {/* <h2 className={general.heading}>{configuratorTitle}</h2> */}

        {!submitted ? (
          <>
            <div className={general.navigationInfos}>
              <p className={general.subHeading}>{navigationHeadline}</p>
              <p>Kostenloses Angebot anfordern.</p>
            </div>

            <div className={general.progressBar}>
              <span
                className={general.progress}
                style={{ width: `${progressPercentage}%` }}
              ></span>
              <span className={general.stepDisplay}>
                {" "}
                {currentStep} / {totalSteps}
              </span>
            </div>

            {currentTitle && nextStepTitle && (
              <div className={general.titleBar}>
                <span className={general.previousStepTitle}>
                  {previousStepTitle}
                </span>
                <span className={general.currentTitle}>{currentTitle}</span>
                <span className={general.nextStepTitle}>{nextStepTitle}</span>
              </div>
            )}
          </>
        ) : null}
      </div>
    );
  }
};

export default TopNavigation;
